import { observer } from 'mobx-react-lite'
import { Avatar, Typography } from 'shared/ui'
import { type ISelectFieldProps, SelectField } from 'shared/ui/Select/SelectField/SelectField'
import styles from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/styles.module.scss'
import { type NewInboxStore } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/store/newInboxStore'

type INewInboxSelectOwnerProps = {
  newInboxStore: NewInboxStore
  excludeMemberIds?: Array<string>
} & Omit<ISelectFieldProps, 'setValue' | 'value' | 'items'>

export const NewInboxSelectOwner = observer(
  ({ newInboxStore, excludeMemberIds, btnProps, ...props }: INewInboxSelectOwnerProps) => {
    const { activeInboxOwner, activeInboxOwnerInfo, membersWithoutObserver, setActiveInboxOwner } =
      newInboxStore
    return (
      <SelectField
        setValue={setActiveInboxOwner}
        value={activeInboxOwner}
        items={membersWithoutObserver.filter((item) =>
          excludeMemberIds?.length ? !excludeMemberIds.includes(String(item.id)) : true
        )}
        btnProps={{
          text: activeInboxOwner ? (
            <Typography
              ariaLabel='name'
              className={styles.selectLine}
              color={
                props.disabled
                  ? 'var(--content-primary-disabled)'
                  : 'var(--content-primary-primary)'
              }
            >
              {activeInboxOwnerInfo?.avatarInfo && (
                <Avatar size={16} info={activeInboxOwnerInfo?.avatarInfo} />
              )}
              {activeInboxOwnerInfo?.full_name}
            </Typography>
          ) : (
            'Select'
          ),
          className: styles.selectOwnerBtn,
          ...btnProps,
        }}
        {...props}
      />
    )
  }
)
